import script from "./StockOutAlertas.vue?vue&type=script&setup=true&lang=js"
export * from "./StockOutAlertas.vue?vue&type=script&setup=true&lang=js"

import "./StockOutAlertas.vue?vue&type=style&index=0&id=0ebd772a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ebd772a"]])

export default __exports__